import React from 'react';

function Header(props) {
  return (
    <div>
      <p>Noteful</p>
    </div>
  );
}

export default Header;